import { patchState, signalStore, withComputed, withMethods, withProps, withState } from '@ngrx/signals';
import { RefillResponsesEndpoint } from '@pims-endpoints';
import { rxResource } from '@angular/core/rxjs-interop';
import { computed } from '@angular/core';

interface RefillResponsesStoreState {
  visitId: string | number;
}

const refillResponsesStoreState: RefillResponsesStoreState = {
  visitId: '',
};

export const RefillResponsesStoreStore = signalStore(
  { providedIn: 'root' },
  withState(refillResponsesStoreState),
  withProps(() => ({
    _refillEndpoint: new RefillResponsesEndpoint(),
  })),
  withProps(store => {
    const _refillResponseResource = rxResource({
      params: () => store.visitId(),
      stream: ({ params }) => store._refillEndpoint.get(params),
    });

    return {
      refillResponseResource: _refillResponseResource,
    };
  }),
  withMethods(store => ({
    setVisitId: (visitId: string | number) => {
      patchState(store, { visitId });
    },
  })),
  withComputed(store => ({
    refillResponses: computed(() => store.refillResponseResource.value() || []),
    openRefillResponse: computed(() => {
      const refills = store.refillResponseResource.value() || [];
      const openRefill = refills.find(refill => refill.status === 'open');
      return {
        hasOpenRefill: !!openRefill,
        responseId: openRefill?.response_id,
      };
    }),
    isLoading: computed(() => store.refillResponseResource.isLoading()),
    hasError: computed(() => !!store.refillResponseResource.error()),
    error: computed(() => store.refillResponseResource.error()),
  })),
);
